"use client"

import { useRealTimeData } from "../hooks/useRealTimeData"
import DeviceStatus from "../components/DeviceStatus"
import SensorGraphs from "../components/SensorGraphs"
import VibrationAnalysis from "../components/VibrationAnalysis"

const DevicesPage = () => {
  const { devices, alerts } = useRealTimeData()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Device Management</h1>
        <p className="text-gray-600">Monitor and manage all IoT devices with advanced vibration analysis</p>
      </div>

      <DeviceStatus devices={devices} />
      <SensorGraphs devices={devices} />

      {/* Add Vibration Analysis for each device */}
      {devices.map((device) => (
        <VibrationAnalysis key={device.id} device={device} alerts={alerts} />
      ))}
    </div>
  )
}

export default DevicesPage
